<ng-container *transloco="let t">
  <div>
    <IFormField>
      <label iLabel>{{ t("update-max-bid.max_bid") }}</label>
      <div iInputGroup>
        <input
          iInputGroupInput
          [disabled]="loading()"
          class="w-full"
          [ngModel]="maxBid"
          type="decimal"
          (ngModelChange)="maxBid = +$event"
          [min]="0"
        />
        <IBadge iInputGroupSuffix [label]="currencySymbol" color="gray" />
      </div>
    </IFormField>

    <div class="flex justify-between pt-4">
      <button iButton variant="secondary" size="md" (click)="ref.close()" [disabled]="loading()">
        {{ t("common.cancel") }}
      </button>
      <button iButton class="w-2/3" [loading]="loading()" (click)="updateMaxBid()" size="md">
        {{ t("common.update") }}
      </button>
    </div>
  </div>
</ng-container>
